import styled from '@emotion/styled';
import {
  Row,
  Column,
  device,
  typography,
  Reveal,
  Segment,
  mobileGutterMargin,
} from '@landsbankinn/ui';
import React from 'react';

interface PointsProps {
  title: React.ReactNode;
  copy: React.ReactNode;
  featured?: React.ReactNode;
  children?: React.ReactNode;
  isGray?: boolean;
}

const Right = Column.withComponent('aside');

const Heading = styled.h2`
  ${typography.h2}
  padding-top: 14px;
  padding-bottom: 32px;
`;

const Copy = styled.div`
  padding-right: 32px;
  margin-bottom: ${(props) => props.theme.breakpoints.sm.gutter}px;

  @media ${device.tablet} {
    margin-bottom: 0;
  }
`;

const Top = styled.div`
  @media ${device.tablet} {
    margin-bottom: 64px;
  }
`;

const Host = styled(Reveal)`
  background: ${(props) => props.theme.colors.backgroundAlt};
  margin-left: ${(props) => `-${props.theme.containerGutter}px`};
  margin-right: ${(props) => `-${props.theme.containerGutter}px`};

  ${mobileGutterMargin}

  @media ${device.tablet} {
    margin: 0;
  }
`;

export const Points = ({
  title,
  copy,
  featured,
  children,
  isGray,
}: PointsProps) => {
  return (
    <Host>
      <Segment isGray={isGray}>
        <Top>
          <Row>
            <Column md={{ width: 8 / 12 }}>
              <Heading>{title}</Heading>
              <Copy>{copy}</Copy>
            </Column>
            <Right md={{ width: 4 / 12 }}>{featured}</Right>
          </Row>
        </Top>
        <Row>{children}</Row>
      </Segment>
    </Host>
  );
};
